import {
  ChangeDetectorRef, Component, EventEmitter,
  Input, Output, OnChanges, SimpleChanges,
} from '@angular/core';
import * as _ from 'lodash';

import { ActiveFilterModel } from '../active-filters/active-filter.model';
import { ARRAY_FILTER_TYPE } from '../active-filters/active-filter-types';

import { BrandService } from '../../brand/brand.service';
import { Option } from 'shared/option/option.model';


@Component({
  moduleId: module.id,
  selector: 'tags-search',
  templateUrl: 'tags-search.component.html',
  styleUrls: ['tags-search.component.scss'],
})
export class TagsSearchComponent implements OnChanges {
  tagsOptions: Array<Option> = [];
  isActive: boolean = true;

  @Input() tags: Array<any> = []; // all attributes list
  @Input() ghostValue: string;
  @Input() filters: Array<ActiveFilterModel> = []; // all active filters

  @Output() selectChange: EventEmitter<any> = new EventEmitter();

  constructor(
    public brandService: BrandService,
    private ref: ChangeDetectorRef,
  ) {}

  /*******************************************
  * COMPONENT GETTERS
  *******************************************/

  get brandId(): string {
    return this.brandService.getBrand();
  }

  get selectedTagsFilters(): Array<any> {
    return this.getTagsFilters();
  }


  /*******************************************
  * COMPONENT HOOKS
  *******************************************/

  ngOnChanges(changes: SimpleChanges) {
    if (changes.tags && changes.tags.currentValue) {
      this.tagsOptions = [];
      _.forEach(this.tags, (tag: string) => {
        this.tagsOptions.push(new Option(tag, tag));
      });
      this.updateSelectedFilters();
    }
    if (changes.filters && changes.filters.currentValue) {
      this.updateSelectedFilters();
    }
  }

  /*******************************************
  * COMPONENT PUBLIC METHODS
  *******************************************/

  public deselectFilter(filter: ActiveFilterModel) {
    const tag = this.getTagOption(filter.title);
    if (tag) { tag.selected = false; }
  }

  public deselectAllFilters() {
    _.forEach(this.tagsOptions, (tag: Option) => {
      tag.selected = false;
    });
  }

  /*******************************************
  * COMPONENT HANDLERS
  *******************************************/

  onMultipleOptionClick(option: any) {
    option.selected = !option.selected;
  }

  /*******************************************
  * COMPONENT PRIVATE METHODS
  *******************************************/

  private getTagsFilters(): Array<ActiveFilterModel> {
    const selected = _.filter(this.tagsOptions, ['selected', true]);
    if (!selected.length) { return []; }

    const filters = _.reduce(selected, (res: any, option: any) => {
      res.push(new ActiveFilterModel(
        'tags',
        option.title,
        ARRAY_FILTER_TYPE,
      ));
      return res;
    }, []);
    return filters;
  }

  private getTagOption(title: string) {
    return _.find(this.tagsOptions, {title});
  }

  private updateSelectedFilters() {
    _.forEach(this.filters, (filter: any) => {
      const tag = this.getTagOption(filter.title);
      if (tag) { tag.selected = true; }
    });
  }
}
